import * as React from 'react';

var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgStoreOutline24 = function SvgStoreOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14h5v9.5h-5V14zm-9 0h6v6H5z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.285 1a1.5 1.5 0 0 0-1.371.89L1.769 7.25h3.206L5.897 1h-.612zM6.91 1l-.922 6.25h3.327L9.47 1H6.91zm3.56 0-.155 6.25h3.37L13.499 1H10.47zm4.03 0 .185 6.25h3.327L17.06 1H14.5zm3.573 0 .952 6.25h3.206l-2.175-5.36A1.5 1.5 0 0 0 18.685 1h-.612zm4.357 7.25h-3.26c.21.728.867 1.25 1.63 1.25.763 0 1.42-.522 1.63-1.25zM18.6 9.344a2.678 2.678 0 0 0 2.2 1.156c1.502 0 2.7-1.242 2.7-2.75v-.106l-2.53-6.16A2.5 2.5 0 0 0 18.685 0h-13.4A2.5 2.5 0 0 0 3 1.485L.5 7.644v.106c0 1.508 1.198 2.75 2.7 2.75.912 0 1.712-.458 2.2-1.156A2.678 2.678 0 0 0 7.6 10.5c.912 0 1.712-.458 2.2-1.156A2.678 2.678 0 0 0 12 10.5c.912 0 1.712-.458 2.2-1.156a2.678 2.678 0 0 0 2.2 1.156c.912 0 1.712-.458 2.2-1.156zm-.57-1.094c-.21.728-.867 1.25-1.63 1.25-.763 0-1.42-.522-1.63-1.25h3.26zm-4.4 0c-.21.728-.867 1.25-1.63 1.25-.763 0-1.42-.522-1.63-1.25h3.26zm-4.4 0H5.97c.21.728.867 1.25 1.63 1.25.763 0 1.42-.522 1.63-1.25zm-4.4 0H1.57c.21.728.867 1.25 1.63 1.25.763 0 1.42-.522 1.63-1.25z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23V10l1-.5V24H2V9.5l1 .5v13h18z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M16.8 18.7H18"
  })));
};

var StoreOutline24Svg = SvgStoreOutline24;

export { StoreOutline24Svg as default };
//# sourceMappingURL=StoreOutline24.svg.js.map
